"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

var _PropertyRecord = _interopRequireDefault(require("./PropertyRecord"));

var PropertyGroupRecord = (0, _immutable.Record)({
  displayName: '',
  displayOrder: 0,
  name: '',
  portalId: null,
  properties: (0, _immutable.List)(),
  hubspotDefined: false
}, 'PropertyGroupRecord');

PropertyGroupRecord.fromJS = function (json) {
  var propertyRecordTransformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _PropertyRecord.default.fromJS;

  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  var properties = json.properties,
      rest = (0, _objectWithoutProperties2.default)(json, ["properties"]);
  return PropertyGroupRecord((0, _extends2.default)({}, rest, {
    properties: Array.isArray(properties) ? (0, _immutable.List)(properties.map(propertyRecordTransformer)) : (0, _immutable.List)()
  }));
};

var _default = PropertyGroupRecord;
exports.default = _default;
module.exports = exports.default;